import React from "react";

const BarCodeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 2.70825C2.84518 2.70825 3.125 2.98807 3.125 3.33325V16.6666C3.125 17.0118 2.84518 17.2916 2.5 17.2916C2.15482 17.2916 1.875 17.0118 1.875 16.6666V3.33325C1.875 2.98807 2.15482 2.70825 2.5 2.70825Z"
      fill="#ED7B30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 2.70825C6.59518 2.70825 6.875 2.98807 6.875 3.33325V14.1666C6.875 14.5118 6.59518 14.7916 6.25 14.7916C5.90482 14.7916 5.625 14.5118 5.625 14.1666V3.33325C5.625 2.98807 5.90482 2.70825 6.25 2.70825Z"
      fill="#ED7B30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.70825C10.3452 2.70825 10.625 2.98807 10.625 3.33325V14.1666C10.625 14.5118 10.3452 14.7916 10 14.7916C9.65482 14.7916 9.375 14.5118 9.375 14.1666V3.33325C9.375 2.98807 9.65482 2.70825 10 2.70825Z"
      fill="#ED7B30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 2.70825C14.0952 2.70825 14.375 2.98807 14.375 3.33325V14.1666C14.375 14.5118 14.0952 14.7916 13.75 14.7916C13.4048 14.7916 13.125 14.5118 13.125 14.1666V3.33325C13.125 2.98807 13.4048 2.70825 13.75 2.70825Z"
      fill="#ED7B30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 2.70825C17.8452 2.70825 18.125 2.98807 18.125 3.33325V16.6666C18.125 17.0118 17.8452 17.2916 17.5 17.2916C17.1548 17.2916 16.875 17.0118 16.875 16.6666V3.33325C16.875 2.98807 17.1548 2.70825 17.5 2.70825Z"
      fill="#ED7B30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.41651 16.6666C5.41651 16.2063 5.78961 15.8333 6.24984 15.8333H6.25733C6.71757 15.8333 7.09066 16.2063 7.09066 16.6666C7.09066 17.1268 6.71757 17.4999 6.25733 17.4999H6.24984C5.78961 17.4999 5.41651 17.1268 5.41651 16.6666Z"
      fill="#ED7B30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.1665 16.6666C9.1665 16.2063 9.5396 15.8333 9.99984 15.8333H10.0073C10.4676 15.8333 10.8407 16.2063 10.8407 16.6666C10.8407 17.1268 10.4676 17.4999 10.0073 17.4999H9.99984C9.5396 17.4999 9.1665 17.1268 9.1665 16.6666Z"
      fill="#ED7B30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9165 16.6666C12.9165 16.2063 13.2896 15.8333 13.7498 15.8333H13.7573C14.2176 15.8333 14.5907 16.2063 14.5907 16.6666C14.5907 17.1268 14.2176 17.4999 13.7573 17.4999H13.7498C13.2896 17.4999 12.9165 17.1268 12.9165 16.6666Z"
      fill="#ED7B30"
    />
  </svg>
);

const BubbleChatIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99627 10H10.0038M13.3259 10H13.3334M6.66669 10H6.67416"
      stroke="#26CF8E"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 18.3334C14.6024 18.3334 18.3334 14.6024 18.3334 10.0001C18.3334 5.39771 14.6024 1.66675 10 1.66675C5.39765 1.66675 1.66669 5.39771 1.66669 10.0001C1.66669 11.3133 2.0018 12.4511 2.5535 13.5206C2.76985 13.94 2.83928 14.4247 2.70367 14.8768L2.1114 16.8511C1.92069 17.4867 2.51337 18.0794 3.14904 17.8887L5.1233 17.2964C5.57532 17.1608 6.06008 17.2302 6.47949 17.4466C7.54901 17.9983 8.68677 18.3334 10 18.3334Z"
      stroke="#26CF8E"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckMarkIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8254 15.8334H15.8334M15.8254 15.8334C15.3065 16.348 14.3661 16.2198 13.7066 16.2198C12.8971 16.2198 12.5073 16.3782 11.9295 16.9559C11.4376 17.4479 10.7781 18.3334 10 18.3334C9.22194 18.3334 8.56244 17.4479 8.0705 16.9559C7.49275 16.3782 7.10293 16.2198 6.2934 16.2198C5.63392 16.2198 4.6935 16.348 4.1746 15.8334C3.65153 15.3147 3.78025 14.3704 3.78025 13.7067C3.78025 12.8679 3.59682 12.4822 2.9995 11.8849C2.11097 10.9964 1.6667 10.5521 1.66669 10.0001C1.6667 9.448 2.11095 9.00375 2.99948 8.11522C3.53269 7.58201 3.78025 7.05365 3.78025 6.29346C3.78025 5.63396 3.6521 4.69353 4.16669 4.17461C4.68538 3.65156 5.62969 3.7803 6.29342 3.7803C7.05358 3.7803 7.58195 3.53275 8.11514 2.99956C9.00369 2.11101 9.44794 1.66675 10 1.66675C10.5521 1.66675 10.9964 2.11101 11.8849 2.99956C12.4179 3.53264 12.9463 3.7803 13.7066 3.7803C14.3661 3.7803 15.3066 3.65214 15.8255 4.16675C16.3485 4.68544 16.2198 5.62974 16.2198 6.29346C16.2198 7.13223 16.4033 7.51789 17.0005 8.11522C17.8891 9.00375 18.3334 9.448 18.3334 10.0001C18.3334 10.5521 17.8891 10.9964 17.0005 11.8849C16.4032 12.4822 16.2198 12.8679 16.2198 13.7067C16.2198 14.3704 16.3485 15.3147 15.8254 15.8334Z"
      stroke="#ED7B30"
      strokeWidth="1.75"
    />
    <path
      d="M7.5 10.7442C7.5 10.7442 8.5 11.2873 9 12.0834C9 12.0834 10.5 8.95841 12.5 7.91675"
      stroke="#ED7B30"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="8" fill="#F6F7F9" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12C20.4142 12 20.75 12.3358 20.75 12.75V21.2119C20.752 21.2095 20.754 21.2072 20.7561 21.2048C20.9668 20.9561 21.1731 20.6933 21.366 20.4476C21.381 20.4285 21.3959 20.4095 21.4107 20.3907C21.6029 20.146 21.8051 19.8889 21.9622 19.7273C22.2509 19.4302 22.7257 19.4235 23.0227 19.7122C23.3198 20.0009 23.3265 20.4757 23.0378 20.7727C22.9491 20.864 22.8035 21.0458 22.5903 21.3172C22.5749 21.3369 22.5592 21.3568 22.5433 21.3771C22.3532 21.6192 22.1302 21.9033 21.9005 22.1745C21.6543 22.4651 21.3787 22.7668 21.1032 23.0015C20.9652 23.119 20.8096 23.235 20.6422 23.3246C20.4807 23.411 20.2583 23.5 20 23.5C19.7417 23.5 19.5193 23.411 19.3578 23.3246C19.1904 23.235 19.0348 23.119 18.8968 23.0015C18.6213 22.7668 18.3458 22.4651 18.0995 22.1745C17.8698 21.9034 17.6468 21.6193 17.4568 21.3772C17.4408 21.3569 17.4252 21.3369 17.4097 21.3172C17.1965 21.0458 17.0509 20.864 16.9622 20.7727C16.6735 20.4757 16.6802 20.0009 16.9773 19.7122C17.2743 19.4235 17.7491 19.4302 18.0378 19.7273C18.1949 19.8888 18.3971 20.146 18.5893 20.3907C18.6042 20.4096 18.6191 20.4286 18.6341 20.4476C18.827 20.6934 19.0333 20.9561 19.2439 21.2048C19.246 21.2072 19.248 21.2095 19.25 21.2119V12.75C19.25 12.3358 19.5858 12 20 12Z"
      fill="#1D61F6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23.5C12.4142 23.5 12.75 23.8358 12.75 24.25C12.75 24.8543 12.7825 25.2875 12.8523 25.6049C12.9201 25.9139 13.0126 26.0635 13.0996 26.1504C13.1865 26.2374 13.3361 26.3299 13.6451 26.3977C13.9625 26.4675 14.3957 26.5 15 26.5H25C25.6043 26.5 26.0375 26.4675 26.3549 26.3977C26.6639 26.3299 26.8135 26.2374 26.9004 26.1504C26.9874 26.0635 27.0799 25.9139 27.1478 25.6049C27.2175 25.2875 27.25 24.8543 27.25 24.25C27.25 23.8358 27.5858 23.5 28 23.5C28.4142 23.5 28.75 23.8358 28.75 24.25C28.75 24.8867 28.7178 25.449 28.6128 25.9268C28.506 26.413 28.3139 26.8583 27.9611 27.2111C27.6083 27.5639 27.163 27.756 26.6768 27.8628C26.199 27.9678 25.6367 28 25 28H15C14.3633 28 13.801 27.9678 13.3232 27.8628C12.837 27.756 12.3917 27.5639 12.0389 27.2111C11.6861 26.8583 11.494 26.413 11.3872 25.9268C11.2822 25.449 11.25 24.8867 11.25 24.25C11.25 23.8358 11.5858 23.5 12 23.5Z"
      fill="#1D61F6"
    />
  </svg>
);

const QrCodeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.71169 3.16519C3.44061 3.20164 3.35564 3.26048 3.30806 3.30806C3.26048 3.35564 3.20164 3.44061 3.16519 3.71169C3.12633 4.00076 3.125 4.39308 3.125 5C3.125 5.60693 3.12633 5.99925 3.16519 6.28831C3.20164 6.5594 3.26048 6.64437 3.30806 6.69195C3.35564 6.73952 3.44061 6.79837 3.71169 6.83481C4.00076 6.87368 4.39308 6.875 5 6.875C5.60693 6.875 5.99925 6.87368 6.28831 6.83481C6.5594 6.79837 6.64437 6.73952 6.69195 6.69195C6.73952 6.64437 6.79837 6.5594 6.83481 6.28831C6.87368 5.99925 6.875 5.60693 6.875 5C6.875 4.39308 6.87368 4.00076 6.83481 3.71169C6.79837 3.44061 6.73952 3.35564 6.69195 3.30806C6.64437 3.26048 6.5594 3.20164 6.28831 3.16519C5.99925 3.12633 5.60693 3.125 5 3.125C4.39308 3.125 4.00076 3.12633 3.71169 3.16519Z"
      fill="#26CF8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.875C10.3452 1.875 10.625 2.15482 10.625 2.5V6.66667C10.625 7.01184 10.3452 7.29167 10 7.29167C9.65482 7.29167 9.375 7.01184 9.375 6.66667V2.5C9.375 2.15482 9.65482 1.875 10 1.875Z"
      fill="#26CF8E"
    />
  </svg>
);

const MobileProtectionIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0834 5.06091V3.21296C17.0834 2.92234 16.8665 2.68113 16.5853 2.63163C15.4519 2.43215 14.5109 1.98839 14.0519 1.74232C13.8639 1.64156 13.6361 1.64156 13.4481 1.74232C12.9891 1.98839 12.0482 2.43215 10.9148 2.63163C10.6335 2.68113 10.4167 2.92234 10.4167 3.21296V5.06091C10.4167 7.47158 12.838 8.7865 13.5534 9.12233C13.6795 9.18158 13.8205 9.18158 13.9467 9.12233C14.662 8.7865 17.0834 7.47158 17.0834 5.06091Z"
      stroke="#1D61F6"
      style={{ stroke: "#1D61F6", strokeOpacity: 1 }}
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M7.91669 1.66675H4.58335C3.66288 1.66675 2.91669 2.41294 2.91669 3.33341V16.6667C2.91669 17.5872 3.66288 18.3334 4.58335 18.3334H12.9167C13.8372 18.3334 14.5834 17.5872 14.5834 16.6667V11.6667"
      stroke="#1D61F6"
      style={{ stroke: "#1D61F6", strokeOpacity: 1 }}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.91669 15.8333H9.58335"
      stroke="#1D61F6"
      style={{ stroke: "#1D61F6", strokeOpacity: 1 }}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export {
  BarCodeIcon,
  BubbleChatIcon,
  CheckMarkIcon,
  DownloadIcon,
  QrCodeIcon,
  MobileProtectionIcon,
};
